import { Calendar } from '@/ui/icons'
import { PageLayout } from '@/ui/layout'

export default function CalendarPage() {
  return (
    <PageLayout>
      <div className="min-h-[60vh] flex flex-col items-center justify-center px-4">
        <div className="rounded-2xl bg-earth-100 p-6 mb-4">
          <Calendar className="h-16 w-16 text-earth-500" aria-hidden />
        </div>
        <h1 className="text-2xl font-semibold text-earth-900 mb-2">Calendar</h1>
        <p className="text-earth-600 text-center">Coming soon</p>
      </div>
    </PageLayout>
  )
}
